import { useCallback, useEffect, useState } from 'react';
import { FILE_UPLOAD_SESSION_STATE_TYPE, useFileUpload } from '../store';

export type FormErrors = {
  global: string[];
  submission: string[];
};

const initialState: FormErrors = {
  global: [],
  submission: [],
};

type UpdatedFormErrors = (updatedFormErrors: Partial<FormErrors>) => void;

type UseFormErrorsReturnType = {
  formErrors: FormErrors;
  resetFormErrors: () => void;
  updateFormErrors: UpdatedFormErrors;
};

export const useFormErrors = (): UseFormErrorsReturnType => {
  const [formErrors, setFormErrors] = useState(initialState);
  const fileUploadState = useFileUpload();

  const resetFormErrors = useCallback((): void => {
    setFormErrors(initialState);
  }, []);
  const updateFormErrors: UpdatedFormErrors = useCallback(
    (updatedFormErrors) => {
      setFormErrors((formErrors) => ({
        ...formErrors,
        ...updatedFormErrors,
      }));
    },
    []
  );

  useEffect(() => {
    const errorMessages: string[] = [];
    if (fileUploadState.session.type === FILE_UPLOAD_SESSION_STATE_TYPE.error) {
      errorMessages.push(fileUploadState.session.errorMessage);
    }
    if (errorMessages.length) {
      updateFormErrors({
        global: errorMessages,
      });
    }
  }, [fileUploadState.session, updateFormErrors]);

  return {
    formErrors,
    resetFormErrors,
    updateFormErrors,
  };
};
